module.exports = __webpack_public_path__ + "static/media/5c_website_logo_diamond_atal.519ec199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5c_website_logo_diamond_atal.jpg
// module id = 87
// module chunks = 0